export default __webpack_public_path__ + "static/media/avatarB2.f2ab2f2d.png";